module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-down--white-bfba61d8059c68d7112c6198060eadc0.svg";